import type { RestoreWizardConfig } from '../types'

export const REPO_WIZARD_CONFIG: RestoreWizardConfig = {
  kind: 'REPOSITORY',
  kindLabel: 'Repository Restore',
  unitIds: { select: 'repo-wz-1', repositories: 'repo-wz-2', targets: 'repo-wz-3', plan: 'repo-wz-4', order: 'repo-wz-5' },
  targetScopeForm: 'REPOSITORIES',
  singleRef: false,
}
